export enum userType {
  admin = "A",
  client = "C",
  technical = "T",
}
